import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import toast from 'react-hot-toast';
import { useStore } from '../../../contexts/store-provider';
import { getTenantIdFromLocalStorage } from '../../../helpers/localstorage-helper';
import { IAddGroupSetting } from '../../../models/forms/IAddUpdateGroupSetting';
import { IFormModalProps } from '../../../models/forms/IForm';
import DefaultModal from '../../../shared-components/modal/default-modal';
import { formatMessage } from '../../../translations/format-message';
import AddEditGroupSettingForm from '../forms/add-edit-group-setting-form';

interface IProps extends IFormModalProps {
  selectedRows: any;
}

const AddEditGroupSetting = (props: IProps) => {
  const { processStore, groupSettingStore } = useStore();
  const {
    GetProcessByIdService,
    resetAddUpdateProcessState,
    resetProcessDetail,
  } = processStore;
  const {
    AddGroupSettingService,
    addUpdateGroupSettingState,
    resetAddUpdateGroupSettingState,
  } = groupSettingStore;

  const initialValues = { GroupName: '' };

  /**
   * The useEffect Hook lets you perform side effects in function component.
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered
   * while a dependency of the useEffect has changed.
   */
  useEffect(() => {
    if (props.id > 0) {
      GetProcessByIdService(props.id);
    }
  }, []);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "addUpdateProcessSuccess" of the useEffect changed.
   */
  useEffect(() => {
    if (addUpdateGroupSettingState.success) {
      if (props.id === -1) toast.success(formatMessage('added_success'));
      else toast.success(formatMessage('updated_success'));
      onModalClosed();
    }
  }, [addUpdateGroupSettingState.success]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "addUpdateProcessError" of the useEffect changed.
   */
  useEffect(() => {
    if (addUpdateGroupSettingState.error) {
      toast.error(formatMessage(addUpdateGroupSettingState.error));
      resetAddUpdateGroupSettingState();
    }
  }, [addUpdateGroupSettingState.error]);

  /**
   * This function adds the Process when "Id < 0" and updates the Existing Process when Id > 0 by providing form values to the
   * correponding function
   */
  const onSubmitForm = (values) => {
    var addObj: IAddGroupSetting = {
      ...values,
      GroupId: props.selectedRows.join(','),
      TenantId: Number(getTenantIdFromLocalStorage()),
    };

    if (props.id < 0) {
      AddGroupSettingService(addObj);
    }
  };

  /**
   * This function closes the pop up modal and reset getProcessdetails, addUpdate Process observables (success, inprogress
   * and error).
   */
  const onModalClosed = () => {
    resetProcessDetail();
    props.modalClosed();
  };

  return (
    <React.Fragment>
      <DefaultModal
        id={props.id}
        className="correction-modal fancy-modal"
        addHeader="assign_group"
        updateHeader="update_process"
        onModalClosed={onModalClosed}
        isLoading={addUpdateGroupSettingState.inProgress}
      >
        <AddEditGroupSettingForm
          id={props.id}
          initialValues={initialValues}
          submitHandler={onSubmitForm}
          onModalClosed={onModalClosed}
          isLoading={addUpdateGroupSettingState.inProgress}
          selectedRows={props.selectedRows}
        />
      </DefaultModal>
    </React.Fragment>
  );
};

export default observer(AddEditGroupSetting);
